import React from 'react'
import Lottie from 'lottie-react'
import PageNoFound from '../Images/404.json'
import { motion } from 'framer-motion'

const ErrorPage = () => {
  return (
    <motion.div
    initial={{ x: "-100vw" }}
    animate={{ x: 0 }}
    transition={{ duration: 1, type: "spring" }} className='container-fluid'>
    <div className='row justify-content-center'>
      <div className='col-12 col-md-6 text-center'>
      <Lottie animationData={PageNoFound} loop={true} className='img-fluid' />
      </div>
    </div>
    <div className='row justify-content-center'>
      <div className='col-12 col-md-6 text-center'>
      <h3 className='text-center' style={{color:'#149686'}}>404 Error : Page Not Found</h3>
      </div>
    </div>
  </motion.div>
  )
}

export default ErrorPage
